import { NewEvidenceFile, EvidenceFile } from '@g17eco/types/file';
import { ValueHistory, EvidenceData } from '@g17eco/types/universalTrackerValue';

export const isNewEvidence = (file: EvidenceFile): file is NewEvidenceFile => {
  return !('_id' in file) && file.type === 'file';
};

/**
 * Normalizes evidence from ValueHistory to use the new evidenceData format.
 * Falls back to legacy evidence array if evidenceData is not available.
 * Matches the backend implementation in api.g17.eco/server/service/utr/utrvHistory.ts
 */
export const normalizeEvidence = (history: Pick<ValueHistory, 'evidence' | 'evidenceData'>): EvidenceData[] => {
  if (history.evidenceData && history.evidenceData.length > 0) {
    return history.evidenceData;
  }
  return history.evidence?.map(docId => ({ documentId: docId })) ?? [];
};
